/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const galleryAppCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {galleryShowFilters, galleryShowSort} = styleParams.booleans;

  return {
    galleryAppContentWidth: galleryShowFilters ? 'calc(100% - min(240px, max(180px, 24%)))' : '100%',
    galleryAppSideFiltersWithSortMarginTop: galleryShowSort ? '10px' : '0',
  };
};
